const DNAComplementMap = {
  ".": ".",
  a: "t",
  t: "a",
  u: "a",
  c: "g",
  g: "c",
  A: "T",
  T: "A",
  U: "A",
  C: "G",
  G: "C",
  r: "y",
  R: "Y",
  y: "r",
  Y: "R",
  d: "h",
  D: "H",
  h: "d",
  H: "D",
  k: "m",
  K: "M",
  m: "k",
  M: "K",
  v: "b",
  V: "B",
  b: "v",
  B: "V"
  //tnrtodo add more letters here
};
export default DNAComplementMap;
